import NipponTA from '../_raw/ui/icon_nippon_ta.svg';
import withIconProps from '@travel/icons/withIconProps';

export default withIconProps(NipponTA, { shouldSetDefaultSize: false });
